import { render, staticRenderFns } from "./FreightTableRouteCard.vue?vue&type=template&id=49c47a28&scoped=true"
import script from "./FreightTableRouteCard.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteCard.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteCard.vue?vue&type=style&index=0&id=49c47a28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c47a28",
  null
  
)

export default component.exports